// src/components/LoadingSpinner.jsx
import { LuCoffee } from 'react-icons/lu';

const LoadingSpinner = ({ message = 'Loading... sambil nyeduh kopi dulu ya ☕' }) => {
  return (
    <div className="flex flex-col items-center justify-center h-64">
      <LuCoffee size={45} className="text-amber-600 animate-pulse" />
      <p className="text-sm text-[var(--text-secondary)] mt-4 animate-pulse">
        {message}
      </p>
      <p className="text-xs text-[var(--text-secondary)] mt-1">
        Sambil ngopi sambil nunggu datanya bro.. ☕
      </p>
    </div>
  );
};

export default LoadingSpinner;